module.exports={close:"閉じる",error:"エラー",info:"情報",success:"成功",warning:"警告"};